/**
 * Converts a positive number to its negative counterpart.
 * If the number is already zero or negative, it remains unchanged.
 *
 * @param {number} value - The number to be converted.
 * @returns {number} The negative of the input number, or the number itself if it's zero or negative.
 */
export const toNegative = (value: number): number => (value === 0 ? 0 : -Math.abs(value));

/**
 * Converts a decimal number to a percentage string, rounded to two decimal places by default with no trailing zeroes.
 *
 * @param {number} value - The decimal number to be converted (e.g., 0.1234).
 * @param {number} [decimals=2] - The number of decimal places to round to.
 * @returns {string} A string representation of the percentage, rounded to two decimal places (e.g., "12.34%").
 */
export const toPercent = (value: number, decimals = 2): string => `${Number((value * 100).toFixed(decimals))}%`;
